import React, { useEffect, useState } from 'react';
import { goToPage } from '../touristESimBlockSlice';
import { connect } from 'react-redux';
const EsimScanPage = (props) => {

  const formSubmmit = () => {
    props.goToPage('packagePage');
  };
  return (
    <div className='tabs-container'>
      <div className='title'>EsimScanPage</div>
      <div className='title'>{props.packageName.value}</div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    packageName: state.touristESimBlock.packageName,
  };
};

const mapDispatchToProps = {
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsimScanPage);
